// ** Navigation imports
import tollSystem from './toll-system'
import common from './common'
import tables from './tables'
import forms from './forms'
import parking from './parking'
import customer from './customer'
// ** Merge & Export
// export default [...tollSystem, ...common]
export default [...customer, ...forms, ...common]
